import { tallyStaticRepAxios } from "src/config/axios.config";
// import { use}
import {
  ATTACHMENT_UPLOAD,
  ATTACHMENT_UPLOAD_SUCCESS,
  ATTACHMENT_UPLOAD_FAILURE,
  GET_ATTACHMENT_LIST,
  GET_ATTACHMENT_LIST_SUCCESS,
  GET_ATTACHMENT_LIST_FAILURE,
  ATTACHMENT_DELETE,
  ATTACHMENT_DELETE_SUCCESS,
  ATTACHMENT_DELETE_FAILURE
} from "../actionTypes";
const uploadAttachment = (formData) => (dispatch) => {
  // Intitial Dispatch // can be used to show loader
  dispatch({
    type: ATTACHMENT_UPLOAD,
  });

  return tallyStaticRepAxios
    .post(`attachments/save`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(
      (res) =>
        dispatch({
          type: ATTACHMENT_UPLOAD_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: ATTACHMENT_UPLOAD_FAILURE,
          payload: err,
        })
    );
};

const getAttachmentList = (type, refId) => (dispatch) =>{
  dispatch({
    type: GET_ATTACHMENT_LIST,
  });

  return tallyStaticRepAxios.get(`attachments/getAllAttachmentByRefIdAndType?type=${type}&refId=${refId}`).then(
    (res) =>
      dispatch({
        type: GET_ATTACHMENT_LIST_SUCCESS,
        payload: res.data,
      }),
    (err) =>
      dispatch({
        type: GET_ATTACHMENT_LIST_FAILURE,
        payload: err,
      })
  );
}

const deleteAttachment = (userName,id) => (dispatch) => {
  // Intitial Dispatch // can be used to show loader
  dispatch({
    type: ATTACHMENT_DELETE,
  });

  return tallyStaticRepAxios
    .post(`attachments/deleteAttachmentById?id=${id}&userName=${userName}`, {})
    .then(
      (res) =>
        dispatch({
          type: ATTACHMENT_DELETE_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: ATTACHMENT_DELETE_FAILURE,
          payload: err,
        })
    );
};

export { uploadAttachment, getAttachmentList, deleteAttachment };
